// ── API Configuration ───────────────────────────────────────────────
// In production (sport-alpha.philiplentz.de), Nginx proxies /api/ to
// the backend on port 8001. In local Docker dev, we hit port 8001 directly.
// This single constant is used by all components for API calls.
const API_BASE = window.location.hostname === "localhost"
  ? "http://localhost:8001"
  : "/api";

// Sandbox mode: show debug columns (Fitness, Calc Time) in Events dashboard
// Only true on sandbox-sport subdomain or localhost
export const IS_SANDBOX = window.location.hostname.includes("sandbox") || window.location.hostname === "localhost";

export default API_BASE;
